import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getPermitDictTreeApi, getPermitCalendarApi, getPermitByDateApi, postPermitDataApi } from 'api'
import { BoundarySlice } from 'redux/reducers'

const initialState = {
    calendarInfo: null, // 被点击的日历信息
    calendarData: null, // 日历上当前范围内显示的总结填写信息
    dictData: null, // 数据字典
    PermitData: null, // 回显数据
    locationName: '', // location 名称
    locationId: '', // location id
    id: '',
    save: false,
}

/* 获取日历上的数据 */
export const getPermitDataCalendarAction = createAsyncThunk('PermitDataSlice/getPermitDataCalendarAction', async (params, thunkAPI) => {
    try {
        const result = await getPermitCalendarApi(params)
        return result?.data?.data
    } catch (error) {
        thunkAPI.dispatch(BoundarySlice.actions.addError(error))
    }
})

/* 获取数据字典*/
export const getPermitDataDictDataAction = createAsyncThunk('PermitDataSlice/getPermitDataDictDataAction', async (dictType, thunkAPI) => {
    const nameDataDict = getPermitDictTreeApi(dictType[0])
    return Promise.all([nameDataDict])
        .then(dictData => dictData)
        .catch(error => thunkAPI.dispatch(BoundarySlice.actions.addError(error)))
})

/* 获取数据 */
export const getPermitDataDataAction = createAsyncThunk('PermitDataSlice/getPermitDataDataAction', async (listDataParams, thunkAPI) => {
    try {
        const data = await getPermitByDateApi(listDataParams)
        return data?.data
    } catch (error) {
        thunkAPI.dispatch(BoundarySlice.actions.addError(error))
    }
})

/* 保存数据 */
export const postPermitDataDataAction = createAsyncThunk('PermitDataSlice/postPermitDataDataAction', async (mmoObj, { dispatch }) => {
    try {
        await postPermitDataApi(mmoObj)
        return true // 已保存状态
    } catch (error) {
        dispatch(BoundarySlice.actions.addError(error))
    }
})

/* 通过日期获取 id */
export const getPermitByDateAction = createAsyncThunk('PermitSlice/getPermitByDateAction', async (listDataParams, thunkAPI) => {
    try {
        const commentData = await getPermitByDateApi(listDataParams) // 通过日期查询 id
        return commentData?.data?.data?.id
    } catch (error) {
        thunkAPI.dispatch(BoundarySlice.actions.addError(error))
    }
}
)

export const PermitSlice = createSlice({
    name: 'PermitSlice',
    initialState,
    reducers: {
        /* 日历点击信息 */
        addCalendarInfo: (state, action) => {
            state.calendarInfo = action.payload
        },
        /* 清空日历与详情页信息 */
        clearListData: state => {
            state.PermitData = null
            state.calendarData = null
            state.save = false
        },
    },
    extraReducers: {
        /* 获取日历上的数据 */
        [getPermitDataCalendarAction.fulfilled.type]: (state, action) => {
            state.calendarData = action.payload
        },

        /* 处理数据字典 */
        [getPermitDataDictDataAction.fulfilled.type]: (state, action) => {
            state.dictData = action.payload
        },

        // /* 通过日期，获取 回显数据 */
        [getPermitDataDataAction.fulfilled.type]: (state, action) => {
            state.PermitData = action.payload
            state.id = action.payload?.data?.id
        },

        /* 通过日期，获取 id */
        [getPermitByDateAction.fulfilled.type]: (state, action) => {
            state.id = action.payload
        },
    },
})
